import React, { useState, useEffect } from 'react';
import moment from 'moment'; // Ensure moment.js is installed
import { Alert } from 'antd'; // Assuming you're using Ant Design's Alert component

const DayEndAlert = () => {
  // Default dayEndTime set to 12 AM tomorrow
  const dayEndTime = moment().add(1, 'day').startOf('day'); // 12:00 AM tomorrow
  const [currentTime, setCurrentTime] = useState(moment());

  // Auto-refresh current time every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment());
    }, 60000); // Update every 60 seconds (1 minute)

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, []);

  // Calculate time difference in minutes, then convert to hours and minutes
  const timeDiffMinutes = currentTime.diff(dayEndTime, 'minutes');
  const hoursDiff = Math.floor(Math.abs(timeDiffMinutes) / 60); // Whole hours
  const minutesDiff = Math.abs(timeDiffMinutes) % 60; // Remaining minutes

  // Determine alert message and type based on time difference
  let alertMessage = '';
  let alertType = 'info';
  let alertColor = '#888'; // Default color

  console.log('Current Time:', currentTime.format('HH:mm'), 'Day End Time:', dayEndTime.format('HH:mm')); // Debug log

  if (timeDiffMinutes < 0) {
    // Day end is upcoming (before 12 AM tomorrow)
    alertMessage = `Day end is due in ${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} and ${minutesDiff} minute${minutesDiff !== 1 ? 's' : ''}`;
    alertType = 'success'; // Green for upcoming
    alertColor = '#52c41a'; // Ant Design success color
  } else {
    // Day end is overdue (at or after 12 AM tomorrow)
    alertMessage = `Day-End Overdue: ${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} and ${minutesDiff} minute${minutesDiff !== 1 ? 's' : ''} delay`;
    alertType = 'error'; // Red for overdue
    alertColor = '#ff4d4f'; // Ant Design error color
  }

  return (
<Alert
  message={
    <>
      <span style={{ marginRight: '8px' }}>⚠️</span>
      {alertMessage}
    </>
  }
  type={alertType}
  showIcon
  style={{
    marginRight: '160px',
    fontSize: '16px',
    padding: '10px 20px', // Increased padding for a more spacious look
    borderRadius: '8px', // Slightly larger radius for a softer look
    fontWeight: '600', // Slightly lighter weight for better readability
    color: alertColor,
    backgroundColor: alertType === 'success' 
      ? 'linear-gradient(90deg, #f6ffed, #e6f7d8)' // Gradient for success
      : 'linear-gradient(90deg, #fff2f0, #ffebe9)', // Gradient for error
    border: `2px solid ${alertType === 'success' ? '#52c41a' : '#ff4d4f'}`, // Stronger border
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', // Deeper shadow for prominence
    transition: 'transform 0.2s ease, box-shadow 0.2s ease', // Smooth hover effect
  }}
  className="day-end-alert" // For additional CSS if needed
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.02)';
    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
  }}
/>    

);
};

export default DayEndAlert;